import { Logger } from '@feature-hub/core';
import { ComponentV2, TrackingDataV2, TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import { FEATURE_APP_NAME } from '~/app/FeatureHubAppDefinition';
import { BaseEvent } from '~/app/tracking/events/base-event';

export class BaseTrackingService {
	private trackingService?: TrackingServiceV2;

	private logger?: Logger;

	protected isInitialized = false;

	initialize(trackingService?: TrackingServiceV2, logger?: Logger) {
		if (this.isInitialized) {
			return;
		}
		this.trackingService = trackingService;
		if (this.trackingService) {
			this.trackingService.featureAppName = FEATURE_APP_NAME;
		}
		this.logger = logger;
		this.isInitialized = true;
	}

	protected track(event: BaseEvent) {
		if (!this.isInitialized) {
			console.warn('Tracking service not initialized');
			return;
		}
		const trackingEvent = event.serialize();
		if (this.logger) {
			this.logger?.info('tracking:', trackingEvent.event?.eventInfo?.eventName, trackingEvent);
		}
		if (this.trackingService) {
			this.trackingService.track(trackingEvent);
		}
	}

	protected overwriteComponent(event: ComponentV2) {
		if (this.trackingService) {
			const datalayer = this.trackingService.getDatalayer();
			if (datalayer.component?.length) {
				datalayer.component[0] = {
					...event,
					componentInfo: { componentName: FEATURE_APP_NAME, componentID: FEATURE_APP_NAME },
				};
			}
		}
	}

	protected registerImpressionTracking(node: Element, event: () => TrackingDataV2) {
		if (!this.isInitialized) {
			console.warn('Tracking service not initialized');
			return;
		}

		this.trackingService?.registerImpressionTracking(node, event);
	}
}
